// Imports: local files.
import {
  GET_TOOLS_START,
  GET_TOOLS_SUCCESS,
  GET_TOOLS_FAILED,
  GET_TOOLS_RESET,
  GET_PARENT_TOOLS_START,
  GET_PARENT_TOOLS_SUCCESS,
  GET_PARENT_TOOLS_FAILED,
  GET_PARENT_TOOLS_RESET,
  GET_TOOL_START,
  GET_TOOL_SUCCESS,
  GET_TOOL_FAILED,
  GET_TOOL_RESET,
  CREATE_TOOL_START,
  CREATE_TOOL_SUCCESS,
  CREATE_TOOL_FAILED,
  CREATE_TOOL_RESET,
  UPDATE_TOOL_START,
  UPDATE_TOOL_SUCCESS,
  UPDATE_TOOL_FAILED,
  UPDATE_TOOL_RESET,
  FILTER_TOOLS_START,
  FILTER_TOOLS_SUCCESS,
  FILTER_TOOLS_FAILED,
  FILTER_TOOLS_RESET,
  DELETE_TOOL_START,
  DELETE_TOOL_SUCCESS,
  DELETE_TOOL_FAILED,
  DELETE_TOOL_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getParents: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  filter: initialLoadingState,
  deleteOne: initialLoadingState,
};

const toolsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Tools
     * =======================================================================
     */
    case GET_TOOLS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOLS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOLS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_TOOLS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get All Tools
     * =======================================================================
     */
    case GET_PARENT_TOOLS_START:
      return { ...state, getParents: { ...action.payload } };
    case GET_PARENT_TOOLS_SUCCESS:
      return { ...state, getParents: { ...action.payload } };
    case GET_PARENT_TOOLS_FAILED:
      return { ...state, getParents: { ...action.payload } };
    case GET_PARENT_TOOLS_RESET:
      return { ...state, getParents: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Tool
     * =======================================================================
     */
    case GET_TOOL_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_TOOL_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create Tool
     * =======================================================================
     */
    case CREATE_TOOL_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_TOOL_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Tool
     * =======================================================================
     */
    case UPDATE_TOOL_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_TOOL_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Filter Tools
     * =======================================================================
     */
    case FILTER_TOOLS_START:
      return { ...state, filter: { ...action.payload } };
    case FILTER_TOOLS_SUCCESS:
      return { ...state, filter: { ...action.payload } };
    case FILTER_TOOLS_FAILED:
      return { ...state, filter: { ...action.payload } };
    case FILTER_TOOLS_RESET:
      return { ...state, filter: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Tool
     * =======================================================================
     */
    case DELETE_TOOL_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_TOOL_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default toolsReducer;
